export enum TimeZone {
  LT = 'LT',
  UTC = 'UTC',
}
